module.exports = __webpack_public_path__ + "img/sky_blue_heart.c1047de5.png";